import classNames from 'classnames';

import styles from './Alert.module.scss';

type Color = 'primary' | 'success' | 'warning' | 'danger';
export interface Props {
  color?: Color;
  className?: string;
  'aria-label'?: string;
  children?: React.ReactNode;
}

const Alert: React.FC<Props> = ({
  children,
  className,
  color = 'success',
  'aria-label': ariaLabel,
}) => (
  <div
    role="alert"
    aria-label={ariaLabel}
    className={classNames(styles.alert, { [styles[color]]: color }, className)}
  >
    {children}
  </div>
);

export default Alert;
